import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DJView from './view/DJView';
import SongRequestForm from './view/SongRequestForm';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import Home from './view/home';
import DataAnalyticsView from './view/DataAnalyticsView';
import DJProfileEditor from './view/DJQRProfileEditor';
import GoogleAnalytics from './components/GoogleAnalytics';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GoogleAnalytics />
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/djv/:djId" element={<DJView />} />
          <Route path="/rs/:formId" element={<SongRequestForm />} />
          <Route path="/analytics/:djId" element={<DataAnalyticsView />} />
          <Route path="/editqrprofile/:formId" element={<DJProfileEditor />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
